import {
  PROFILE_ROUTE_NAMES,
  ROUTE_PATH_LIST,
} from '../../../../constants/route'

// TODO: §11 types `thread_id` as an int and the Emails section addresses a
// thread by that id; the mock still serves the fixture's `thr-<listing>-<applicant>`
// string, so `Read` stays disabled with a reason until the contract lands.
export function checkIsOverviewThreadAddressable(row) {
  return Number.isInteger(Number(row.thread_id))
}

export function getOverviewCommunicationThreadLink(threadId) {
  return PROFILE_ROUTE_NAMES.emailThreadNG({ id: threadId })
}

// TODO: `Show all` lands on the Emails section unscoped — neither half of
// AC-RP08-16's target exists: there is no applicant-thread scope, and
// `unread` is not an Emails section value (EMAILS_SECTION_SUB_VALUES), so
// `?sub=unread` answers 400 and used to break this link.
export function getOverviewCommunicationsShowAllLink() {
  return `/${ROUTE_PATH_LIST.mails}`
}
